/**
 * Subscribe/notify plus a `stable` snapshot cache for `useSyncExternalStore`.
 * The type annotation is optional unless you are using the snapshot cache and `stable` fn.
 * Usage and rules: client/docs/EXTERNAL-STORES.md
 */
export const createExternalStore = <T>() => {
  const listeners = new Set<() => void>();

  const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  };

  const notify = () => listeners.forEach((listener) => listener());

  const cache = new Map<string, { serialized: string; value: T }>();
  const stable = (value: T, slot = ''): T => {
    const serialized = JSON.stringify(value ?? null);
    const hit = cache.get(slot);

    if (hit?.serialized === serialized) return hit.value;

    cache.set(slot, { serialized, value });
    return value;
  };

  return { notify, stable, subscribe };
};
